
import { Delete01Icon, InformationSquareIcon } from 'hugeicons-react';
import React, { useEffect, useState } from 'react';
import api, { API_URL } from '../../api';
import toast from 'react-hot-toast';
import '../../assets/css/account/account-page.css';
import { PrimaryButton, SecondaryButton } from '../../components/forms/buttons';
import { UserCircleIcon, Mail01Icon } from 'hugeicons-react';
import { DataListInput, TextInput } from '../../components/forms/Input';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';

import DashboardContainer from '../../components/dashboard/DashboardContainer';
import { useParams } from 'react-router-dom';

const AccountPageContent = () => {
    const { userId } = useParams();
    const [userData, setUserData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [position, setPosition] = useState('');
    const [date, setDate] = useState(null);
    const [photo, setPhoto] = useState('');
    const [hospital, setHospital] = useState('');

    const formatDate = (dateObject) => {
        if (!dateObject) return '';
        return new Intl.DateTimeFormat('en-GB').format(dateObject);
    };

    const handleSave = (e) => {
        e.preventDefault();
        setIsSaving(true);

        // Format the date before saving
        const formattedDate = formatDate(date?.$d);

        setTimeout(() => {
            console.log({ fullName, email, position, formattedDate, hospital, photo });
            toast.success('Form saved successfully!');

            setIsSaving(false);
        }, 2000);
    };

   

    const handleDeleteClick = () => {
        setIsPopupOpen(true);
    };

    const confirmDelete = () => {
        setIsPopupOpen(false);
        toast.success('Account deleted successfully!');
    };

    const closePopup = () => {
setIsPopupOpen(false);
    };

    const handlePhotoCapture = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPhoto(URL.createObjectURL(file));
        }
    };

  

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                
                const response = await api.get(`${API_URL}/user/profile/`
                  );
                const user = response.data;
    
          
                
                setUserData(user);
                setFullName((user.first_name + ' ' + user.last_name) || '');
                setEmail(user.email || '');
                setPosition(user.position || '');
                setHospital(user.hospital || '');
                setDate(user.date_created ? new Date(user.date_created) : null);
                setPhoto(user.photo || '');
    
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching user data:', error);
                toast.error('Failed to load user data.');
                setIsLoading(false);
            }
        };
    
        fetchUserData();
    }, [userId]);
    

    return isLoading ? 'Getting Data...' : (
        <div className='account-page'>
            <div className='account-data'>
                <div className="account-contents">
                    <div className="empty-text"></div>
                    <div className="titleName-deleteBtn">
                        <h3>{fullName || 'User Name'}</h3>
                        <SecondaryButton
                            isLoading={isSaving}
                            onClick={handleDeleteClick}
                            processingText={''}
                            iconClass={<Delete01Icon />}
                            buttonText={'Delete Account'}
                        />
                    </div>

                    <div className="profilInfo">
                        <div className="profil-image-text">
                            <h3>Profile Picture</h3>
                            <div className="profil-img">
                                <img src={photo || "/images/account/Profile.jpg"} alt="Profile" />
                                {/* <Camera01Icon
                                    className="camera-icon"
                                    onClick={handleCameraClick}
                                /> */}
                                <input
                                    id="cameraInput"
                                    type="file"
                                    accept="image/*"
                                    capture="camera"
                                    style={{ display: 'none' }}
                                    onChange={handlePhotoCapture}
                                />
                            </div>
                        </div>

                        <div className="infoForm">
                            <h3>Information</h3>
                            <form className='account-form' onSubmit={handleSave}>
                                <div className="full-field">
                                    <TextInput
                                        label={'Full Name'}
                                        iconClass={<UserCircleIcon />}
                                        id={'fullName'}
                                        name={'fullName'}
                                        placeholder={"Enter a name"}
                                        value={fullName}
                                        readOnly={true}
                                        setValue={setFullName}
                                    />
                                </div>
                                <div className="full-field">
                                    <TextInput
                                        label={'Position'}
                                        iconClass={<UserCircleIcon />}
                                        id={'position'}
                                        name={'position'}
                                        placeholder={"Position"}
                                        value={fullName}
                                        readOnly={true}
                                        setValue={setFullName}
                                    />
                                </div>

                                <div className="field-account">
                                    <div className="hospital-select">
                                        <DataListInput
                                            iconClass={<ArrowDropDownIcon />}
                                            id={"hospitals"}
                                            name={"hospitals"}
                                            label={"Select a hospital"}
                                            placeholder={"Select a hospital"}
                                            value={hospital}
                                            readOnly={true}
                                            setValue={setHospital}
                                            options={["Pawhuska", "Mangum", "Carnegie", "Seiling", "Prague"]}
                                        />
                                    </div>
                                    <div className="email">
                                        <TextInput
                                            type={'email'}
                                            label={'Email'}
                                            iconClass={<Mail01Icon />}
                                            id={'email'}
                                            name={'email'}
placeholder={"Enter your email"}
                                            value={email}
                                            setValue={setEmail}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {isPopupOpen && (
                <div className="popup overlay">
                    <div className="popup-content">
                        <div className="popup-text-icon">
                            {<InformationSquareIcon className="info-icon" />}
                            <div className="popup-delete-text">
                                <h3>Delete</h3>
                                <p>Do you really want to delete your account?</p>
                            </div>
                        </div>

                        <div className="buttons">
                            <SecondaryButton onClick={closePopup} buttonText={'Cancel'} />
                            <PrimaryButton onClick={confirmDelete} buttonText={'Delete'} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const AccountPage = () => {
    return (
        <DashboardContainer content={<AccountPageContent />} pageTitle={'Account'} />
    );
};

export default AccountPage;
